<div class="form-group form-inline" style="margin-bottom:0;">
  <input class="form-control" value="{{name}}">
  <button data-action="save" class="btn btn-default">save</button>
  <button data-action="cancel" class="btn btn-default">cancel</button>
</div>
